import prepareOptions from '../../prepareOptions';
import {
  VALUE_500,
  VALUE_1000,
  VALUE_1500,
  VALUE_2000,
  VALUE_2500,
  VALUE_3000,
  VALUE_3500,
  VALUE_4000,
  VALUE_4500,
  VALUE_5000,
  VALUE_6000,
  VALUE_7000,
  VALUE_8000,
  VALUE_9000,
  VALUE_10000,
  VALUE_11000,
  VALUE_12000,
  VALUE_13000,
  VALUE_14000,
  VALUE_15000,
  VALUE_17500,
  VALUE_20000,
  VALUE_22500,
  VALUE_25000,
  VALUE_27500,
  VALUE_30000,
  VALUE_35000,
  VALUE_40000,
  VALUE_45000,
  VALUE_50000,
  VALUE_55000,
  VALUE_60000,
  VALUE_70000,
  VALUE_80000,
  VALUE_90000,
  VALUE_100000,
  VALUE_110000,
  VALUE_120000,
  VALUE_130000,
  VALUE_140000,
  VALUE_150000,
} from './values.js';

export default prepareOptions([
  VALUE_500,
  VALUE_1000,
  VALUE_1500,
  VALUE_2000,
  VALUE_2500,
  VALUE_3000,
  VALUE_3500,
  VALUE_4000,
  VALUE_4500,
  VALUE_5000,
  VALUE_6000,
  VALUE_7000,
  VALUE_8000,
  VALUE_9000,
  VALUE_10000,
  VALUE_11000,
  VALUE_12000,
  VALUE_13000,
  VALUE_14000,
  VALUE_15000,
  VALUE_17500,
  VALUE_20000,
  VALUE_22500,
  VALUE_25000,
  VALUE_27500,
  VALUE_30000,
  VALUE_35000,
  VALUE_40000,
  VALUE_45000,
  VALUE_50000,
  VALUE_55000,
  VALUE_60000,
  VALUE_70000,
  VALUE_80000,
  VALUE_90000,
  VALUE_100000,
  VALUE_110000,
  VALUE_120000,
  VALUE_130000,
  VALUE_140000,
  VALUE_150000,
]);
